/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Tv_Signin_DescriptionInputs */

const de_login_tv_signin_description = /** @type {(inputs: Login_Tv_Signin_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestätigen Sie den Code, der auf Ihrem Gerät angezeigt wird.`)
};

/** @type {(inputs: Login_Tv_Signin_DescriptionInputs) => LocalizedString} */
const en_login_tv_signin_description = de_login_tv_signin_description;

/**

* @param {Login_Tv_Signin_DescriptionInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const login_tv_signin_description = /** @type {((inputs?: Login_Tv_Signin_DescriptionInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Tv_Signin_DescriptionInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_login_tv_signin_description(inputs)
	return en_login_tv_signin_description(inputs)
});